import React from 'react';

import cs from 'classnames';
import moment from 'moment-tz';

import {gt} from 'app/utils/i18n';

interface Props {
  guestUntil: string;
}

export function InnerGuestUserInfoCard({guestUntil}: Props): JSX.Element {
  const untilMoment = moment(guestUntil);
  const expired = moment().isAfter(untilMoment);
  const formated = (
    <span className="font-weight-bold">{untilMoment.format('ll')}</span>
  );

  return (
    <div className={cs('small', {'text-danger': expired})}>
      {expired
        ? gt('Access expired on %s', formated)
        : gt('Access expires on %s', formated)}
    </div>
  );
}
